module.exports = __webpack_public_path__ + "img/title@2x.5e07bb20.png";